<template>
  <div>
    <div v-if="$route.query.token">
      <v-alert v-if="verify == -1" color="info" dark>
        <v-progress-circular class="mr-4" indeterminate></v-progress-circular>正在验证您的邮箱...
      </v-alert>
      <v-alert
        v-if="verify != -1 && typeof verify === 'boolean'"
        :type="verify ? 'success' : 'error'"
        dark
      >{{verify ? '邮箱验证成功。' : '邮箱验证失败：'+ verifySmg}}</v-alert>
      <v-card-actions class="pa-0" v-if="verify != -1">
        <v-spacer></v-spacer>
        <v-btn to="/">回到首页</v-btn>
      </v-card-actions>
    </div>
    <div v-else>
      <v-alert type="error">请正确请求该地址。</v-alert>
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <v-btn to="/">回到首页</v-btn>
      </v-card-actions>
    </div>
  </div>
</template>

<script>
import jsonp from "jsonp";
export default {
  data() {
    return {
      verify: -1,
      verifySmg: ""
    };
  },
  mounted() {
    let BASE_API_URL = "https://api-lcs.makjust.com/1.1/verifyEmail/";
    setTimeout(() => {
      if (this.$route.query.token) {
        let token = this.$route.query.token;
        jsonp(BASE_API_URL + token, null, (err, data) => {
          if (err) {
            this.verify = false;
            this.verifySmg = "请求验证时发生了错误，请稍后再试。";
          } else {
            if (data.error) {
              this.verify = false;
              this.verifySmg = data.error;
            } else {
              this.verify = true;
            }
          }
        });
      }
    }, 1500);
  }
};
</script>